import { render, staticRenderFns } from "./ProjectsViewTasks.vue?vue&type=template&id=ab70cd2c"
import script from "./ProjectsViewTasks.vue?vue&type=script&lang=js"
export * from "./ProjectsViewTasks.vue?vue&type=script&lang=js"
import style0 from "./ProjectsViewTasks.vue?vue&type=style&index=0&id=ab70cd2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports